import * as React from "react";
import HelpPanel from "@cloudscape-design/components/help-panel";

export const HomepageInformationSlider = () => {
  return (
    <HelpPanel header={<h2>More information</h2>}>
      <div>
        <p>
          This page visualizes a car collection. The bar chart compares average
          top speed and how many cars sit in each category. The table lists
          every car with its manufacturer, country of origin, category, top
          speed, and main use.
        </p>

        <h4>Where the data comes from</h4>
        <p>
          Cars are stored in a DynamoDB table and served through a GraphQL API
          on AWS AppSync, resolved by a single TypeScript Lambda. The page
          calls the <code>listCars</code> query on load. Use the Refresh button
          on the table to pull the latest data.
        </p>

        <h4>Customizing the layout</h4>
        <p>
          The panels on this page use a draggable board layout. You can drag
          items to rearrange them and resize cards to fit the view you prefer.
        </p>

        <h4>Supported operations</h4>
        <p>The API exposes full CRUD against the collection:</p>
        <ul>
          <li>
            <code>listCars</code> and <code>getCar</code> for reads
          </li>
          <li>
            <code>createCar</code> to add a car
          </li>
          <li>
            <code>updateCar</code> for partial updates, so omitted fields keep
            their existing values
          </li>
          <li>
            <code>deleteCar</code>, which returns the deleted record
          </li>
        </ul>

        <p>
          Top speeds are recorded in miles per hour. Values are sample data
          entered for demonstration and are not fact checked.
        </p>
      </div>
    </HelpPanel>
  );
};
